import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const formsAssistant: ThemeUICSSObject = {
  modalRow: {
    '&': {
      position: 'relative',
      'div[data-variant="layout.ai.execution.formsAssistant.buttonsDiv"]': {
        position: 'absolute',
        top: '7%',
        right: '15%',
      },
    },
  },
  modal: {
    'div[class="modal__main"]': { position: 'relative' },
    'div[data-variant="layout.ai.execution.formsAssistant.buttonsDiv"]': {
      position: 'absolute',
      top: '5.4%',
      right: '17%',
    },
  },
  buttonsDiv: {
    display: 'flex',
    justifyContent: 'end',
    gap: 2,
    alignItems: 'center',

    'button.manualButton:nth-child(2)': {
      marginLeft: 'auto',
    },
  },

  settingsButton: {
    variant: 'buttons.icon-outline',
    border: 'none',
  },

  openTextarea: {
    position: 'fixed',
    bottom: '1%',
    right: '0.5%',
    zIndex: 'menu',
  },
  tableText: { wordBreak: 'normal' },
  thModal: { whiteSpace: 'nowrap' },

  genericWindowDragger: {
    maxWidth: '600px',
    maxHeight: '455px',
    height: '455px',
    zIndex: 'menu',
    bottom: '49px',
    right: '11px',
  },

  customGridWindowDragger: {
    variant: 'layout.ai.execution.formsAssistant.genericWindowDragger',
    bottom: 'auto',
    right: 'auto',
    '.tooltip__wrapper': {
      padding: '0px',
    },
  },

  floatingWindow: {
    p: 5,
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.section',
    minWidth: '478px',
    height: '100%',

    '#assistantForm': {
      alignItems: 'end',
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      maxHeight: '58vh',
      height: '100%',
    },

    'input[type="file"]': {
      display: 'none',
    },

    '.gpt__buttonsContainer': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      gap: 1,
    },

    'button[data-variant="icon-outline-danger"]': {
      border: 'none',
    },

    '.gpt__form': {
      flexDirection: 'column',
      display: 'flex',
      gap: 2,
    },
    '.formsAssistant__closeButton': {
      borderRadius: '5px',
      top: '-7px',
      right: '-7px',
      position: 'absolute',
    },
    '#assistantForm .history': {
      height: '300px',
      overflow: 'hidden',
      display: 'flex',
      minHeight: '5vh',
    },
    '.autoscrollContainer': { overflow: 'auto' },
  },

  phoneCase: {
    p: 5,
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.section',
    height: '100%',
    justifyContent: 'space-between',

    'input[type="file"]': {
      display: 'none',
    },

    '.gpt__buttonsContainer': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      gap: 1,
    },

    'button[data-variant="icon-outline-danger"]': {
      border: 'none',
    },

    'div[data-variant="layout.common.chat.form"]': {
      minHeight: '60%',
    },
    'div[data-variant="layout.common.chat.form"] + div': {
      width: '100%',
      height: '29%',
    },

    '.gpt__form': {
      flexDirection: 'column',
      display: 'flex',
      gap: 2,
      height: '100%',
    },
    '.formsAssistant__closeButton': {
      borderRadius: '5px',
      top: '-7px',
      right: '-7px',
      position: 'absolute',
    },
    '.history': {
      height: '200px',
      overflow: 'hidden',
      display: 'flex',
    },
    '.autoscrollContainer': { overflow: 'auto' },
  },

  configurationTable: {
    variant: 'layout.common.tables.information',
    'th:last-of-type': {
      width: '100px',
    },
  },

  overrideTable: {
    '.attTitle': { fontWeight: 'bold' },
    'div[role="dialog"]': {
      width: '95vw',
    },
    '.confirmNewValues': {
      variant: 'layout.common.tables.information',
      tableLayout: 'fixed',
      width: '100%',

      'div[role="dialog"]': {
        width: '95vw',
      },

      '& thead': {
        th: {
          width: '50%',
        },
        'th:last-of-type': {
          width: '100px',
        },
        'th:first-of-type': {
          width: '199px',
        },
      },

      '& tbody': {
        'td:last-of-type': {
          textAlign: 'center',
        },
      },
    },
  },
};

export default formsAssistant;
